import React from 'react';
import { Header, Segment, Divider } from 'semantic-ui-react';
import styled from 'styled-components';

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  @media (max-width: 768px) {
    padding: 10px;
  }
`;

const Title = styled(Header)`
  color: #333;
  margin-bottom: 15px;

  @media (max-width: 768px) {
    margin-bottom: 10px;
    font-size: 1.5em !important;
  }
`;

const Text = styled.p`
  line-height: 1.6;
  color: #444;
  white-space: pre-line;
  margin-bottom: 15px;

  @media (max-width: 768px) {
    line-height: 1.4;
    font-size: 0.9em;
  }
`;

const TextSpace = styled.p`
  line-height: 1.6;
  color: #444;
  white-space: pre-line;
  margin-bottom: 15px;
  margin-left: 10%;

  @media (max-width: 768px) {
    line-height: 1.4;
    font-size: 0.9em;
  }
`;

const Section = styled.div`
  margin-bottom: 20px;
`;

const List = styled.ul`
  list-style-type: disc;
  padding-left: 20px;
  margin-bottom: 15px;

  @media (max-width: 768px) {
    padding-left: 15px;
    margin-bottom: 10px;
  }
`;

const ListItem = styled.li`
  margin-bottom: 8px;

  @media (max-width: 768px) {
    margin-bottom: 5px;
    font-size: 0.9em;
  }
`;

const SubList = styled.ul`
  list-style-type: lower-alpha;
  padding-left: 20px;
  margin-bottom: 15px;

  @media (max-width: 768px) {
    padding-left: 15px;
    margin-bottom: 10px;
  }
`;

const SubListItem = styled.li`
  margin-bottom: 8px;

  @media (max-width: 768px) {
    margin-bottom: 5px;
    font-size: 0.9em;
  }
`;

const TermsOfService = () => {
  return (
    <Container>
      <Title as="h1">Termos e Condições de Uso</Title>

      <Segment>
        <Text>
          Olá! Antes de utilizar a nossa plataforma (&quot;Plataforma&quot;), é
          importante que você leia com atenção os termos e condições abaixo
          estipulados (&quot;Termos de Uso&quot;). Assim, você (&quot;Você&quot;
          ou &quot;Usuário&quot;) poderá aproveitar a Plataforma e todas as
          funcionalidades disponibilizadas por meio dela.
        </Text>

        <Text>
          A Plataforma faz parte do serviço oferecido pela solução Financeira e
          de Gestão Escolar (&quot;Solução&quot;), contratada pela escola à qual
          você e/ou seus pais e/ou responsáveis legais estão vinculados, e
          possui diversas funcionalidades.
        </Text>

        <Text>
          Caso não concorde com alguma regra deste documento, não use a
          Plataforma! Ao usá-la, Você aceita todas as condições aqui descritas.
          Ao marcar a opção &quot;aceito&quot; no final, Você está dizendo que
          concorda integralmente com o que está escrito neste documento.
        </Text>

        <Text>
          Quando Você aceita estes Termos de Uso, está declarando que tem mais
          de 18 (dezoito) anos ou que tem autorização dos seus responsáveis
          legais.
        </Text>

        <Text style={{ fontWeight: 'bold' }}>
          ATENÇÃO! SE VOCÊ É MENOR DE IDADE, É ESSENCIAL QUE SEU RESPONSÁVEL
          LEGAL LEIA E ACEITE OS TERMOS DE USO EM SEU NOME.
        </Text>

        <Text>
          A Plataforma é oferecida pelo do Grupo Arco Educação (&quot;ARCO&quot;
          ou &quot;Grupo&quot;), somos um grupo econômico composto por empresas
          que oferecem serviços para o ramo educacional, dividido em soluções
          pedagógicas educacionais (focadas no ensino básico e tradicional),
          soluções pedagógicas educacionais complementares (focadas na educação
          socioemocional, bilíngue e maker), soluções Financeiras e de Gestão
          Escolar e Social.
        </Text>

        <Text>
          Fazem parte do nosso Grupo as seguintes empresas: Activesoft
          Tecnologia e Serviços LTDA., Arco Instituto de Educação, Classapp
          Sistemas LTDA., Companhia Brasileira de Educação e Sistemas de Ensino
          S.A., Isaac Tecnologia & Serviços LTDA., Me Salva Cursos e Consultoria
          S.A. e SAE Digital S.A.
        </Text>

        <Divider />

        <Title as="h2">1. OBJETO</Title>
        <Section>
          <Text>
            1.1. A Plataforma tem como objetivo disponibilizar um ambiente
            digital para a hospedagem, organização e compartilhamento de
            conteúdo educacional para os Você e os demais usuários
            (&quot;Usuários&quot;).
          </Text>
          <Text>
            1.2. Na Plataforma, Você pode acessar as seguintes funcionalidades e
            conteúdos, entre outros:
          </Text>
          <List>
            <ListItem>
              Livros, apostilas e outros materiais didáticos (&quot;Conteúdo
              Didático&quot;);
            </ListItem>
            <ListItem>Atividades complementares;</ListItem>
            <ListItem>
              Obtenção de respostas às suas dúvidas sobre assuntos abordados no
              Conteúdo Didático.
            </ListItem>
          </List>
          <Text>
            1.3. A Plataforma poderá alterar ou inserir funcionalidades além das
            descritas acima a depender do Sistema de Ensino utilizado pela sua
            escola.
          </Text>
        </Section>

        <Divider />

        <Title as="h2">2. RESPONSABILIDADES</Title>
        <Section>
          <Text>
            2.1. Estes Termos de Uso estabelecem as responsabilidades, os
            deveres e as obrigações que Você assume ao acessar e/ou utilizar a
            Plataforma e seus serviços relacionados, tais como softwares,
            complementos, plugins, barras e acessórios, exceto quando regido por
            um termo de uso separado e específico.
          </Text>
          <Text>
            Você está ciente de que, se houver algum erro na Plataforma, ele
            será corrigido assim que possível.
          </Text>
          <TextSpace>
            2.1.1. A ARCO emprega todos os esforços possíveis para que a
            Plataforma esteja sempre disponível. Porém, podem ocorrer
            indisponibilidades temporárias que fogem do controle e
            responsabilidade da empresa, como manutenções necessárias ou
            situações inesperadas, como desastres naturais, falhas com a
            Internet ou até um ataque cibernético. Embora a empresa se esforce
            para manter a plataforma e seus serviços operantes, é inerente a
            serviços online a ocorrência de eventuais interrupções e paradas
            temporárias.
          </TextSpace>
          <TextSpace>
            2.1.2. Em caso de indisponibilidade, a empresa empreenderá todos os
            esforços razoáveis para restabelecer o acesso à Plataforma no menor
            tempo possível, considerando as limitações técnicas próprias e de
            terceiros, dos quais depende para manter-se online, e aplicará
            medidas de mitigação de riscos necessárias.
          </TextSpace>
          <TextSpace>
            2.1.3. Quando houver manutenções programadas que causem a
            indisponibilidade da Plataforma por mais tempo, vamos avisar
            antecipadamente por e-mail e nas nossas redes sociais.
          </TextSpace>
          <Text>
            2.2. Você se compromete a tomar os cuidados necessários para
            garantir a segurança de sua infraestrutura de informática empregada
            no momento da utilização dos serviços disponíveis na Plataforma.
          </Text>
          <TextSpace>
            2.2.1. Entende-se por cuidados necessários o uso de um equipamento
            de informática em bom estado, com sistema operacional atualizado,
            firewall pessoal, sistemas antivírus e anti-spyware.
          </TextSpace>
          <Text>
            2.3. É de responsabilidade do Usuário, também, a adoção de boas
            práticas de segurança com suas informações de acesso, tais como
            usuário e senha.
          </Text>
          <Text>2.4. Além das condições citadas, Você NÃO poderá:</Text>
          <SubList>
            <SubListItem>
              Transmitir ou enviar informações de qualquer natureza que possam
              incitar, induzir ou promover atitudes discriminatórias, mensagens
              violentas ou delituosas que atentem contra aos bons costumes, à
              moral ou, ainda, que contrariem a ordem pública;
            </SubListItem>
            <SubListItem>
              Cadastrar-se com informações falsas, desatualizadas, ou de
              propriedade de terceiros;
            </SubListItem>
            <SubListItem>
              Utilizar as informações, os produtos e/ou serviços disponíveis na
              Plataforma para fins diversos daqueles a que se destinam e sem
              autorização expressa da ARCO;
            </SubListItem>
            <SubListItem>
              Alterar, apagar e/ou corromper dados e informações de terceiros;
            </SubListItem>
            <SubListItem>Violar a privacidade de qualquer Usuário;</SubListItem>
            <SubListItem>
              Violar propriedade intelectual da ARCO e de terceiros em geral, ou
              seja, de direito autoral, marca, patente etc., por meio de
              reprodução, distribuição e/ou compartilhamento indevido de
              material, sem a prévia autorização do proprietário;
            </SubListItem>
            <SubListItem>
              Usar &quot;nome de usuário&quot; que guarde semelhança com o nome
              do Sistema de Ensino utilizado na Plataforma e outros pertencentes
              ao mesmo Grupo Econômico;
            </SubListItem>
            <SubListItem>
              Transmitir ou enviar arquivos com vírus de computador, com
              conteúdo invasivo, destrutivo ou que cause danos temporários ou
              permanentes nos equipamentos do destinatário e/ou das Plataformas;
            </SubListItem>
            <SubListItem>
              Utilizar nomes, apelidos e/ou imagens considerados ofensivos, bem
              como os que contenham dados pessoais de qualquer Usuário;
            </SubListItem>
            <SubListItem>
              Transmitir ou enviar informações de propriedade de terceiros;
            </SubListItem>
            <SubListItem>
              Usar endereços de computadores, de rede e/ou de correio
              eletrônico, falsos;
            </SubListItem>
            <SubListItem>
              Utilizar, para quaisquer finalidades e por quaisquer meios de
              divulgação, imagens, expressões, nomes, e/ou apelidos que
              identifiquem, insinuem ou sugiram que as informações publicadas
              por Você pertencem à Plataforma, ou que fazem parte de suas
              promoções;
            </SubListItem>
            <SubListItem>
              Utilizar materiais que contenham qualquer vírus, worms, malware e
              outros programas de computador que possam causar danos à
              Plataforma e/ou aos demais Usuários;
            </SubListItem>
            <SubListItem>
              Realizar a divulgação de materiais ilegais, agressivos,
              caluniosos, abusivos, difamatórios, discriminatórios, ameaçadores,
              danosos, invasivos da privacidade de terceiros, terroristas,
              vulgares, obscenos ou, ainda, condenáveis de qualquer tipo ou
              natureza que sejam prejudiciais a menores e à preservação do meio
              ambiente de algum modo;
            </SubListItem>
            <SubListItem>
              Anexar URLs, endereços de e-mail ou outro material publicitário
              que tenha cunho de anúncio e/ou publicidade de terceiros, sem
              prévia autorização da ARCO; e
            </SubListItem>
            <SubListItem>
              Utilizar a Plataforma para quaisquer fins ilícitos.
            </SubListItem>
          </SubList>
        </Section>

        <Divider />

        <Title as="h2">3. CADASTRO DO USUÁRIO NA PLATAFORMA</Title>
        <Section>
          <Text>
            3.1. A Plataforma somente poderá ser acessada por Usuários
            devidamente cadastrados.
          </Text>
          <Text>
            3.2. Para fins destes Termos de Uso, os Usuários são as pessoas
            físicas autorizadas a se cadastrar na Plataforma para acessar o
            Conteúdo Didático e as demais funcionalidades de aprendizado
            disponíveis, sendo eles colaboradores, professores e/ou alunos.
          </Text>
          <TextSpace>
            3.2.1. Os campos para cadastro de Usuário deverão ser preenchidos
            por Você com informações completas, recentes, válidas e corretas,
            sendo de sua exclusiva responsabilidade manter todas as informações
            fornecidas em razão do cadastro permanentemente atualizadas, de
            forma a sempre refletir os seus dados reais.
          </TextSpace>
          <TextSpace>
            3.2.2. Ao criar uma conta de acesso na Plataforma, Você concorda que
            poderá receber, no e-mail e/ou telefone informados no cadastro,
            mensagens com avisos e conteúdo publicitário de produtos ou serviços
            da Plataforma, do Sistema de Ensino e/ou de seus parceiros.
          </TextSpace>
          <Text>
            3.3. Mediante a aceitação destes Termos de Uso, Você concorda e está
            ciente de que qualquer interação com a Plataforma, considerada
            questionável pela administração do portal, mesmo que não prevista
            nas condições acima citadas, estará sujeita a avaliação e
            consequente suspensão ou cancelamento do seu acesso.
          </Text>
          <Text>
            3.4. O descumprimento das condições e observações destes Termos de
            Uso dá à Plataforma o direito de cancelar, suspender, excluir e/ou
            desativar o cadastro e/ou o material enviado por Você, temporária ou
            definitivamente, ao seu único e exclusivo critério, sem prejuízo das
            cominações legais pertinentes e sem a necessidade de comunicar ao
            Usuário a ação tomada dentro do seu sistema.
          </Text>
          <Text>
            3.5. Você é o único responsável pelas atividades que ocorrem com seu
            cadastro e login, devendo guardar sua senha de acesso em local
            seguro. Você deve notificar a Plataforma imediatamente sobre
            qualquer violação de segurança, perda de senha ou uso não autorizado
            de seu cadastro. Você será o único responsável pelas operações
            efetuadas em sua conta.
          </Text>
          <Text>
            3.6. Caberá à Você informar imediatamente à Plataforma acerca de
            quaisquer alterações nas informações fornecidas quando do respectivo
            cadastro, devendo mantê-las sempre atualizadas.
          </Text>
          <Text>
            3.7. Por força destes Termos de Uso, Você aceita ser identificado
            pelo sistema da Plataforma como, por exemplo, no uso de cookies e/ou
            de outras tecnologias. Com isso, buscamos a melhoria contínua dos
            serviços prestados pela ARCO e suas afiliadas.
          </Text>
        </Section>

        <Divider />

        <Title as="h2">4. INTELIGÊNCIA ARTIFICIAL (IA)</Title>
        <Section>
          <Text>
            4.1. Nossas Plataformas podem utilizar Inteligência Artificial
            (&quot;IA&quot;) para aprimorar a experiência dos Usuários e
            otimizar os serviços oferecidos. Sempre que a IA for empregada,
            garantimos que seu uso será seguro, transparente e em conformidade
            com a legislação aplicável, incluindo as normas de proteção de dados
            e privacidade.
          </Text>
          <Text>
            4.2. A ARCO adota medidas técnicas e organizacionais para garantir a
            segurança e a confiabilidade dos sistemas de IA eventualmente
            utilizados, contando com soluções licenciadas e fornecidas por
            parceiros especializados.
          </Text>
          <Text>
            4.3. Eventuais soluções de IA são integradas às Plataformas de
            maneira controlada e responsável, assegurando que qualquer
            tratamento de dados observe as regras da Política de Privacidade da
            ARCO.
          </Text>
          <Text>
            4.4. Caso uma funcionalidade de IA esteja disponível em alguma de
            nossas Plataformas, informaremos aos Usuários de maneira clara e
            objetiva, detalhando seu funcionamento e eventuais restrições de
            uso.
          </Text>
        </Section>

        <Divider />

        <Title as="h2">5. PROPRIEDADE INTELECTUAL</Title>
        <Section>
          <Text>
            5.1. Todos os materiais da ARCO e suas Soluções Educacionais,
            incluindo, mas não se limitando, a apresentação, layout, marcas,
            logotipos, sistemas, produtos, denominações de serviços e quaisquer
            outros materiais, inclusive bases de dados, programas, arquivos,
            imagens, vídeos ou materiais de qualquer outra natureza e que tenham
            contratualmente autorizadas suas veiculações nestas plataformas, são
            protegidos pela legislação nacional de proteção à Propriedade
            Intelectual, incluindo, mas não se limitando à Lei no 9.279, de 14
            de maio de 1996.
          </Text>
          <Text>
            5.2. São licenciados ou de titularidade da ARCO e demais empresas do
            Grupo, os direitos de uso e propriedade de todos os materiais
            divulgados na Plataforma pelo Sistema de Ensino, sendo que a
            reprodução, a transmissão e a distribuição de tais materiais não são
            permitidas sem o expresso consentimento por escrito da ARCO ou do
            respectivo titular, sobretudo para fins econômicos ou comercial.
          </Text>
          <Text>
            5.3. O uso da Plataforma e de todas as suas funcionalidades,
            incluindo a IA generativa, não gera qualquer presunção de
            transferência de propriedade intelectual ou licença de uso de
            direitos autorais ou de propriedade industrial. Todos os direitos
            autorais, marcas e demais obras passíveis de proteção de propriedade
            intelectual constantes dos serviços da Plataforma são para uso
            pessoal, individual, intransferível e sempre dentro do âmbito de sua
            relação com o Sistema de Ensino e com a escola, por essa razão, Você
            não deverá comercializar, compartilhar ou usar no todo ou em parte o
            conteúdo da Plataforma por quaisquer meios, onerosamente ou não,
            sabendo que se o fizer poderá ser penalizado civil e penalmente pela
            ARCO e/ou por qualquer terceiro titular do conteúdo.
          </Text>
          <Text>
            5.4. Será caracterizada como infração da legislação vigente, o uso
            indevido de materiais protegidos por propriedade intelectual
            (direito autoral, marcas comerciais, patentes, etc.) apresentados na
            Plataforma, sujeitando-se o Usuário infrator às medidas judiciais
            cabíveis à espécie, sem prejuízo de eventual indenização por perdas
            e danos e honorários advocatícios à ARCO, bem como a terceiros que
            venham a sofrer pelo ato do Usuário.
          </Text>
          <Text>
            5.5. Você declara ainda estar ciente de que os riscos derivados da
            utilização da Plataforma são de sua total responsabilidade. Assim,
            se o seu uso resultar na necessidade de serviços e/ou reposição de
            material, equipamento, propriedade ou informação do Usuário, a ARCO
            e demais empresas do Grupo não serão responsáveis por tais custos.
          </Text>
          <Text>
            5.6. Os produtos, conteúdos, informações, valores, serviços,
            sistemas e/ou softwares, publicados pelo Sistema de Ensino na
            Plataforma, podem conter imprecisões e/ou erros de grafia, razão
            pela qual a Plataforma compromete-se a tomar as medidas necessárias
            para manter a plataforma atualizada periodicamente.
          </Text>
        </Section>

        <Divider />

        <Title as="h2">6. PRIVACIDADE</Title>
        <Section>
          <Text>
            A ARCO respeita a privacidade e proteção de dados dos seus Usuários.
            Por isso, a ARCO desenvolveu uma Política de Privacidade do Grupo.
            Neste sentido, a ARCO recomenda que os Usuários leiam esta política,
            que está disponível na Plataforma através do link:&nbsp;
            <a href="https://politicaprivacidade.arcoeducacao.com.br/">
              https://politicaprivacidade.arcoeducacao.com.br/
            </a>
            , para saber como seus dados pessoais são tratados, bem como para
            conhecer seus direitos.
          </Text>
        </Section>

        <Divider />

        <Title as="h2">7. ALTERAÇÃO DOS TERMOS DE USO</Title>
        <Section>
          <Text>
            7.1. A Plataforma poderá alterar, modificar e/ou ajustar estes
            Termos de Uso a qualquer tempo, sendo que essas alterações,
            modificações e/ou ajustes terão efeito somente após se tornarem
            públicos.
          </Text>
          <Text>
            7.2. Fica a critério exclusivo da Plataforma suspender e/ou
            inabilitar definitivamente o acesso, bem como de aplicar as medidas
            jurídicas cabíveis, ao Usuário que utilizar a Plataforma com intuito
            considerado ilícito, ofensivo, inadequado ou fora do contexto ao
            qual se destina.
          </Text>
          <Text>
            7.3. A ARCO e demais empresas do Grupo poderão fazer mudanças nos
            serviços, produtos, informações e quaisquer outros materiais dos
            Sistemas de Ensino e da Plataforma sem a necessidade de enviar
            qualquer notificação prévia a Você e, portanto, sem o direito de
            indenização a qualquer Usuário.
          </Text>
          <Text>
            7.4. Você se obriga a rever os Termos de Uso da Plataforma
            regularmente, restando claro que sua relação conosco é regida pelos
            Termos de Uso vigentes no momento de seu acesso ou do uso dos
            serviços prestados pela Solução Educacional e da Plataforma.
          </Text>
          <Text>
            7.5. De nenhum modo a ARCO será responsabilizada por qualquer dano
            direto, indireto, especial, incidental ou de qualquer fato
            resultante do uso da Plataforma, inclusive por quaisquer
            informações, produtos e/ou serviços obtidos por meio dela ou em
            decorrência do seu uso.
          </Text>
          <Text>
            7.6. A Plataforma poderá conter links para outros sites operados por
            terceiros que não o Sistema de Ensino e demais empresas do Grupo.
            Estes links são fornecidos somente para sua referência, e a
            Plataforma não tem controle sobre esses outros sites e não se
            responsabiliza pelo seu conteúdo, sendo que a inclusão desses links
            nas referidas plataformas não implica na aprovação do material ou
            qualquer associação com seus proprietários.
          </Text>
          <TextSpace>
            7.6.1. Você declara estar ciente de que, ao acessar e usar os sites
            citados acima e, por conseguinte suas informações, materiais,
            produtos e/ou serviços, estará agindo por sua conta e risco. A ARCO
            não se responsabilizará por quaisquer danos decorrentes deste
            procedimento.
          </TextSpace>
          <Text>
            7.7. O previsto nos itens acima também se aplica aos sites que
            possuam links para a Plataforma, uma vez que o Sistema de Ensino não
            possui qualquer controle ou ingerência sobre os mesmos e, em razão
            disso, Você declara estar ciente de que se acessar a Plataforma, por
            meio de quaisquer links hospedados em outros sites, estará agindo
            por sua conta e risco, e o Sistema de Ensino e/ou a Plataforma não
            se responsabilizarão por quaisquer danos decorrentes deste
            procedimento.
          </Text>
          <Text>
            7.8. A Plataforma não se responsabilizará pelas mensagens, agendas,
            eventos, avaliações e/ou atividades complementares, inseridos na
            Plataforma diretamente pelos Usuários, sejam eles alunos, pais ou
            responsáveis, professores e/ou gestores escolares.
          </Text>
          <Text>
            7.9. A disponibilização da Plataforma tem duração indeterminada e a
            Solução Educacional reserva-se ao direito de terminar, suspender ou
            interromper unilateralmente e a qualquer momento, sem necessidade de
            prévio aviso ou posterior, à disponibilização da Plataforma, ou sua
            inteira transformação e modificação.
          </Text>
        </Section>

        <Divider />

        <Title as="h2">8. DISPOSIÇÕES GERAIS</Title>
        <Section>
          <Text>
            8.1. <b>Nulidade.</b> Se alguma disposição destes Termos de Uso for
            julgada nula, inaplicável ou sem efeito, o restante continuará em
            vigor.
          </Text>
          <Text>
            8.2. <b>Lei aplicável e foro.</b> Estes Termos de Uso serão
            interpretados segundo a legislação brasileira e fica eleito o foro
            da Comarca da Cidade de São Paulo, no Estado de São Paulo, para
            dirimir qualquer controvérsia.
          </Text>
          <Text>
            8.3. Ficou com alguma dúvida? Nos envie um e-mail. Quaisquer
            dúvidas, sugestões e/ou solicitações poderão ser feitas pelo e-mail
            jurídico@arcoeducacao.com.br.
          </Text>
        </Section>

        <Divider />

        <Text>
          DECLARO QUE LI E ACEITO OS TERMOS E CONDIÇÕES DE USO DA PLATAFORMA.
        </Text>
      </Segment>
    </Container>
  );
};

export default TermsOfService;
